import React, { useEffect, useRef } from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useWallet } from '@solana/wallet-adapter-react';
import { useAuthStore } from '../store/authStore';
// import { Wallet, LogOut } from 'lucide-react';

export default function WalletConnection() {
  const { connected, publicKey, disconnect } = useWallet();
  const { user, login, logout } = useAuthStore();
  const loginAttempted = useRef<string | null>(null);

  // Auto-login when wallet connects
  useEffect(() => {
    if (connected && publicKey && !user) {
      const walletAddr = publicKey.toString();
      // Prevent infinite retry loop — only attempt once per wallet address
      if (loginAttempted.current === walletAddr) return;
      loginAttempted.current = walletAddr;
      login(walletAddr);
    }
  }, [connected, publicKey, user, login]);

  // Reset login guard when wallet changes or user logs out manually
  useEffect(() => {
    if (!connected) {
      loginAttempted.current = null;
      if (user) logout();
    }
  }, [connected, user, logout]);

  if (connected && publicKey) {
    return (
      <div className="bg-[#009245]/10 border border-[#009245]/30 rounded-lg px-3 py-2 flex items-center space-x-3">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-[#009245] rounded-full animate-pulse shadow-sm shadow-[#009245]"></div>
          <div className="text-xs">
            <div className="text-[#009245] font-semibold">Connected</div>
            <div className="font-mono text-xs text-gray-400">
              {publicKey.toString().slice(0, 4)}...{publicKey.toString().slice(-4)}
            </div>
          </div>
        </div>
        <button
          onClick={disconnect}
          className="text-xs px-2 py-1 text-gray-400 hover:text-white transition-colors"
        >
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <div className="bg-[#052393]/20 border border-[#052393]/40 rounded-lg px-3 py-2">
      <WalletMultiButton className="!bg-gradient-to-r !from-[#2AAAEA] !to-[#052393] !text-white hover:!shadow-lg hover:!shadow-[#2AAAEA]/50 !rounded-lg !px-4 !py-2 !text-sm !font-bold !transition-all" />
    </div>
  );
}
